import type { CommunityPost } from "../../services/communityService";

/** Demo posts shown when Firestore is empty / unavailable. */
export const SEED_COMMUNITY_POSTS: CommunityPost[] = [
  {
    id: "seed-1",
    authorId: "seed",
    authorName: "AceCollector",
    authorPhotoURL: null,
    text: "Pulled this beauty at my local shop today — Freedom Ascension looking sharp! Who else is building a blue deck?",
    imageUrls: [
      "https://creative.cdn.apm.any-digital.com/h5/findpoketcgstore/product-page-images/gd05-freedom-ascension-6.webp",
    ],
    likeCount: 12,
    commentCount: 3,
    likedBy: [],
    createdAt: new Date(Date.now() - 1000 * 60 * 45),
    isSeed: true,
  },
  {
    id: "seed-2",
    authorId: "seed",
    authorName: "RayquazaFan",
    authorPhotoURL: null,
    text: "Storm Emerald pre-orders are live near me. Anyone hunting Mega Rayquaza ex? Drop your local store below!",
    imageUrls: [
      "https://creative.cdn.apm.any-digital.com/h5/findpoketcgstore/product-page-images/m6-storm-emeralda-5.webp",
      "https://creative.cdn.apm.any-digital.com/h5/findpoketcgstore/product-page-images/m6-storm-emeralda-6.webp",
    ],
    likeCount: 28,
    commentCount: 7,
    likedBy: [],
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 5),
    isSeed: true,
  },
  {
    id: "seed-3",
    authorId: "seed",
    authorName: "OnePiecePilot",
    authorPhotoURL: null,
    text: "Friday night locals were stacked. Love this community — share your best pull of the week!",
    imageUrls: [],
    likeCount: 19,
    commentCount: 4,
    likedBy: [],
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 26),
    isSeed: true,
  },
];
